import request from './axios'
import { API_ENDPOINTS } from './constants'

export const getSignUpInformation = async region => {
  const response = await request
    .get(API_ENDPOINTS.signUpInformation(region))
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
